module.exports = __webpack_public_path__ + "static/media/menu-servicos.26b8a257.svg";